export const getCustomerRouteKey = (customer) => {
  if (!customer || typeof customer !== 'object') {
    return null;
  }

  return customer.uid
    || customer.customer_uid
    || customer.id
    || customer.customer_id
    || null;
};

export default getCustomerRouteKey;
